import request from '@/utils/request'

export function fetchInfo(query) {
    return request({
        url: '/vue-element-admin/article/list',
        method: 'get',
        params: query
    })
}

export function fetchHomePage() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/homepage/info',
        method: 'get'
    })
}

export function fetchProject(type) {
    return request({
        url: `https://dirc.sjtu.edu.cn/api/v1/project/info?id=${type}`,
        method: 'get'
    })
}

export function fetchNews() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/news/info',
        method: 'get'
    })
}

export function fetchFaculty() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/faculty/info',
        method: 'get'
    })
}

export function fetchSteering() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/steering/info',
        method: 'get'
    })
}

export function fetchGuest() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/guest/info',
        method: 'get'
    })
}

export function fetchAlumni() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/alumni/info',
        method: 'get'
    })
}

export function fetchStudent() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/student/info',
        method: 'get'
    })
}

export function fetchCourse() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/course/info',
        method: 'get'
    })
}

export function fetchPhotList() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/picture/info',
        method: 'get'
    })
}

export function fetchPaperList() {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/publication/info'
    })
}

export function fetchLectureInfo(id) {
    return request({
        url: 'https://dirc.sjtu.edu.cn/api/v1/lecture/info?id=' + id
    })
}